import { apis, callApi } from "../api";

export async function downloadFile(file) {
	try {
		const response = await callApi({
			method: "POST",
			url: apis.GET_DOWNLOAD_URL,
			body: {
				fileName: file.name,
				location: file.location,
			},
		});
		if (!response?.downloadURL) {
			return;
		}

		const res = await callApi({
			method: "GET",
			url: response.downloadURL,
			baseURL: "",
			responseType: "blob",
		});
		const url = window.URL.createObjectURL(new Blob([res]));
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", `${file.name}`);
		document.body.appendChild(link);
		link.click();
	} catch (error) {}
}
